module.exports = __webpack_public_path__ + "5d2f971898875a185f60ecc1872a4499.jpg";